/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.
 */
const flatpickr = require("flatpickr");

(function() {
    var token = document.head.querySelector('meta[name="csrf-token"]');

    if (token) {
        var op = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function(method, url) {
            var resp = op.apply(this, arguments);
            if (typeof url === 'string' && url.includes('maps.googleapis.com')) {
                return resp;
            }
            this.setRequestHeader('X-CSRF-Token', token.content);
            return resp;
        };
    } else {
        console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    }
}());

/**
 * Toggle preloader
 */
window.togglePreloader = function (show) {
    if (show) {
        $('.page-loader').show();
    } else {
        $('.page-loader').hide();
    }
};

/**
 * Convert to title case
 */
window.titleCase = function (str, delimiter) {
    return str.split(delimiter).map(function(val){
        return val.charAt(0).toUpperCase() + val.substr(1).toLowerCase();
    }).join(' ');
};

/**
 * Redirects the page
 */
window.redirectPage = function (redirect_url) {
    if (redirect_url) {
        if (redirect_url.indexOf('#') == 0) {
            window.location.hash = redirect_url;
            window.location.reload();
        } else {
            window.location.replace(redirect_url);
        }
    } else {
        window.location.reload();
    }
};

/**
 * Display validation errors
 */
window.showValidationErrorMsg = function (xhr, form, findByClass) {
    var response = xhr.responseText;
    var error_prefix = findByClass ? '.' : '#';

    try {
        response = JSON.parse(response);
    } catch (e) {
    }

    var msg_title = response.hasOwnProperty('errors') ? 'There are some errors in your inputs.' : response.message;
    var msg = '<br/><br/>';

    if (response.hasOwnProperty('errors')) {
        var errors = response.errors;
        for (var field in errors) {
            msg += '<div class="mb-2 bd-text-left">';
            if (errors.hasOwnProperty(field)) {
                var field_errors = errors[field];
                msg += '<strong>' + titleCase(field, '_') + ':</strong><ul>';
                var lis = '';

                for (var i = 0; i < field_errors.length; i++) {
                    var text = field_errors[i];
                    text = $('<div />').text(text).html(); // escape html

                    lis += '<li>' + text + '</li>';
                }

                if (form) {
                    var key = field.replace(/[^a-z0-9 -]/g, '-');
                    var second_key = '';

                    // check for array validation
                    if (field.indexOf('.') > -1) {
                        second_key = field.substring(0, field.indexOf('.'));
                        second_key = second_key.replace(/[^a-z0-9 -]/g, '-') + '-\\.';
                    }

                    form.find(error_prefix + key + '-error').html(lis).show();

                    if (second_key) {
                        form.find(error_prefix + second_key + '-error').html(lis).show();
                    }

                    form.find('[name="' + field + '"]').addClass('is-invalid');
                }

                msg += lis;
                msg += '</ul><div>';
            }
        }

        if (form) {
            var first_error = form.find('.is-invalid').first();
            if (first_error.length) {
                $('html, body').animate({
                    scrollTop: first_error.offset().top - 85
                }, 1000);
            }
        }
    }

    Swal.fire({
        title: 'Error!',
        html: form ? msg_title : msg_title + msg,
        icon: 'error',
        confirmButtonText: 'Ok'
    });
};


$(document).ready(function () {

    $('.counter').countUp();
    $('[data-dropzone-url]').each(function() {
        var dropzone_url = $(this).data('dropzone-url');
        var data = $(this).data('dropzone-data') || {};
        var param_name = $(this).data('dropzone-param') || 'file';
        var delete_url = $(this).data('dropzone-delete-url');
        var files = $(this).data('dropzone-files') || {};
        var max_files = $(this).data('dropzone-max-files') || null;
        var max_size = $(this).data('dropzone-max-size') || 2;
        var accepted = $(this).data('dropzone-accept') || 'image/png, image/jpeg';
        var auto_process = ! ($(this).data('dropzone-delay-submit') || false)
        var parent_el = this;


        var dropzone_el = new Dropzone(this, {
            url: dropzone_url,
            paramName: param_name,
            autoProcessQueue: auto_process,
            dictResponseError: 'Error uploading file!',
            dictDefaultMessage: 'Drop files here to upload',
            dictFileTooBig: 'File is too big ({{filesize}} MB). Max filesize: {{maxFilesize}} MB',
            dictInvalidFileType: 'You can\'t upload files of this type.',
            maxFilesize: max_size,
            maxFiles: max_files,
            uploadMultiple: false,
            parallelUploads: 50,
            acceptedFiles: accepted,
            error: function(file, response) {
                var message = response;

                if (typeof message !== 'string') {
                    message = message.error ? message.error : 'Error uploading file!';
                }

                file.previewElement.classList.add('dz-error');
                var _ref = file.previewElement.querySelectorAll('[data-dz-errormessage]');
                var _results = [];
                var _len = _ref.length;

                for (var _i = 0; _i < _len; _i++) {
                    var node = _ref[_i];
                    _results.push(node.textContent = message);
                }

                return _results;
            },
            init:function() {

                if (data) {
                    this.on('sending', function (file, xhr, formData) {
                        for (const key in data) {
                            if (data.hasOwnProperty(key)) {
                                var val = data[key];
                                var form_val = val;

                                // find dynamic value
                                if (typeof val === 'object' && val.hasOwnProperty('el')) {
                                    form_val = $(val.el).val();

                                    if (! form_val) {
                                        form_val = val.default;
                                    }

                                }

                                formData.append(key, form_val);
                            }
                        }
                    });
                }

                this.on('maxfilesexceeded', function(file){
                    this.removeFile(file);
                    Swal.fire({
                        title: 'Warning!',
                        text: 'Maximum number of allowed files exceeded.',
                        confirmButtonText: 'Ok',
                        icon: 'warning',
                    });
                });

                this.on('success', function(file, response) {
                    file.id = response.id;
                    file.delete_url = response.delete_url;

                    if (response.thumb && file.previewElement && file.previewElement.classList.contains('dz-file-preview')) {
                        if (response.type === 'video') {
                            file.previewElement.classList.add('dz-image-preview');
                        }

                        file.thumb = response.thumb;
                        this.emit('thumbnail', file, file.thumb);
                    }
                });

                this.on('addedfile', function(file) {
                    // Create the remove button
                    var removeButton = Dropzone.createElement('<a class="dz-remove">Remove file</a>');

                    if (file.type === 'video') {
                        file.previewElement.classList.add('dz-image-preview');
                    }

                    // Capture the Dropzone instance as closure.
                    var _this = this;
                    // Listen to the click event
                    removeButton.addEventListener('click', function(e) {
                        // Make sure the button click doesn't submit the form:
                        e.preventDefault();
                        e.stopPropagation();

                        // Remove the file preview.
                        if (typeof(file.id) !== 'undefined') {
                            Swal.fire({
                                title: 'Are you sure you want to remove this file?',
                                text: 'You will not be able to undo this delete operation!',
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonText: 'Yes, Delete!',
                                cancelButtonText: 'Cancel',
                            }).then(function (result) {
                                if (result.value) {
                                    //remove file extension
                                    var id = file.id;

                                    $.ajax({
                                        type: 'DELETE',
                                        url: delete_url || file.delete_url,
                                        contentType: 'application/json',
                                        beforeSend: function () {
                                            toggleLoading($(removeButton), true);
                                        },
                                        complete: function () {
                                            toggleLoading($(removeButton), false);
                                        },
                                        success: function (data) {
                                            _this.removeFile(file);
                                            notify('Success!', 'File' + file.name + ' removed successfully.', 'success');
                                        },
                                        error: function (jqXHR, textStatus, errorThrow) {
                                            if (jqXHR.status != 404) {
                                                notify('Error!', 'Error while removing file' + file.name, 'danger');
                                            } else {
                                                _this.removeFile(file);
                                            }
                                        }
                                    });
                                }
                            });
                        } else {
                            _this.removeFile(file);
                        }
                    });

                    // Add the button to the file preview element.
                    file.previewElement.appendChild(removeButton);
                });

                //add files to dropzone
                for (var i in files) {
                    var file = files[i];
                    file.accepted = true;

                    this.files.push(file);
                    this.emit('addedfile', file);
                    this.emit('thumbnail', file, file.thumb);
                    this.emit('complete', file);
                }
            }
        });

    });

    $("*[data-custom-modal]").click(function() {
        var modalValue = $(this).data("custom-modal");
        var modal = $(`#${modalValue}`);
        modal.addClass("custom-modal-active");
        $("body").css("overflow", "hidden");
    });
    $("*[data-close-custom-modal]").click(function() {
        var modalValue = $(this).data("close-custom-modal");
        var modal = $(`#${modalValue}`);
        modal.removeClass("custom-modal-active");
        $("body").css("overflow", "auto");
    });

    $('[data-play-youtube]').click(function (e) {
        e.preventDefault();

        var embed_url = $(this).data('play-youtube');
        var video_wrapper = $(this).parent('.video-wrapper');

        video_wrapper.html('<iframe src="' + embed_url + '" title="YouTube video" allowfullscreen></iframe>');
    });
});

// CountUp
(function( $ ){
    "use strict";

    $.fn.countUp = function( options ) {

        // Defaults
        var settings = $.extend({
            'time': 2000,
            'delay': 10
        }, options);

        return this.each(function(){

            // Store the object
            var $this = $(this);
            var $settings = settings;

            var counterUpper = function() {
                if(!$this.data('counterupTo')) {
                    $this.data('counterupTo',$this.text());
                }
                var time = parseInt($this.data("counter-time")) > 0 ? parseInt($this.data("counter-time")) : $settings.time;
                var delay = parseInt($this.data("counter-delay")) > 0 ? parseInt($this.data("counter-delay")) : $settings.delay;
                var divisions = time / delay;
                var num = $this.data('counterupTo');
                var nums = [num];
                var isComma = /[0-9]+,[0-9]+/.test(num);
                num = num.replace(/,/g, '');
                var isInt = /^[0-9]+$/.test(num);
                var isFloat = /^[0-9]+\.[0-9]+$/.test(num);
                var decimalPlaces = isFloat ? (num.split('.')[1] || [])?.length : 0;

                // Generate list of incremental numbers to display
                for (var i = divisions; i >= 1; i--) {

                    // Preserve as int if input was int
                    var newNum = parseInt(Math.round(num / divisions * i));

                    // Preserve float if input was float
                    if (isFloat) {
                        newNum = parseFloat(num / divisions * i).toFixed(decimalPlaces);
                    }

                    // Preserve commas if input had commas
                    if (isComma) {
                        while (/(\d+)(\d{3})/.test(newNum.toString())) {
                            newNum = newNum.toString().replace(/(\d+)(\d{3})/, '$1'+','+'$2');
                        }
                    }

                    nums?.unshift(newNum);
                }

                nums = nums.map((num)=>String(num).padStart(2, '0'));

                $this.data('counterup-nums', nums);
                $this.text('0');

                // Updates the number until we're done
                var f = function() {
                    $this.text($this.data('counterup-nums')?.shift());
                    if ($this.data('counterup-nums')?.length) {
                        setTimeout($this.data('counterup-func'),delay);
                    } else {
                        delete $this.data('counterup-nums');
                        $this.data('counterup-nums', null);
                        $this.data('counterup-func', null);
                    }
                };
                $this.data('counterup-func', f);

                // Start the count up
                setTimeout($this.data('counterup-func'),delay);
            };

            // Perform counts when the element gets into view
            $this.waypoint(counterUpper, { offset: '100%', triggerOnce: true });
        });

    };

})( jQuery );


// Select2 hehe
$.fn.select2.defaults.set('theme', 'bootstrap-5');
